import React from 'react'
import {
  List,
  // Select,
  useTable,
  Table,
  TextField,
  Space,
  EditButton,
  Button,
  Popconfirm,
  Icons,
} from '@pankod/refine-antd'
import Head from 'next/head'
import {
  IResourceComponentsProps,
  GetListResponse,
  CrudFilters,
  useGetIdentity,
} from '@pankod/refine-core'

import { TCommonError } from 'src/interfaces/common'
import Filter, { TFilterForm } from '@components/ContentFilter'
import { ModalLMSAdmin } from './blocks/ModalLMSAdmin'
import {
  canDeleteAdmin,
  getEditableAdminFields,
  ROLE_OPTIONS,
} from './role-acl'

import type { TLMSAdmin, TLMSAdminModalState, TLMSAdminRole } from './types'

export const LMSAdminManagementList: React.FC<
  IResourceComponentsProps<GetListResponse<any>>
> = ({ options }) => {
  const { tableProps, searchFormProps } = useTable<
    TLMSAdmin,
    TCommonError,
    TFilterForm<TLMSAdmin>
  >({
    resource: 'admins',
    dataProviderName: 'lms',
    queryOptions: {
      initialData: {
        data: [],
        total: 0,
      },
    },
    onSearch: (params) => {
      const filters: CrudFilters = []
      const { email } = params
      filters.push(
        {
          field: 'email',
          operator: 'eq',
          value: email,
        },
        // disable for now
        // {
        //   field: 'role',
        //   operator: 'eq',
        //   value: role,
        // },
        {
          field: 't',
          operator: 'eq',
          value: new Date().getTime(),
        },
      )
      return filters
    },
    syncWithLocation: true,
  })

  const { data } = useGetIdentity<{ user: { LMSRole: TLMSAdminRole } }>()
  const LMSRole = data?.user?.LMSRole || ''

  const [modalState, setModalState] = React.useState<TLMSAdminModalState>(null)

  return (
    <List
      title="LMS Admin Management"
      createButtonProps={{
        children: 'Assign New Admin',
        onClick: () => {
          setModalState({ type: 'create' })
        },
      }}
    >
      <Head>
        <title>LMS Admin | {options?.label}</title>
      </Head>

      <ModalLMSAdmin
        modalState={modalState}
        setModalState={setModalState}
        roleOptions={ROLE_OPTIONS}
      />

      <Filter
        formProps={searchFormProps}
        items={[
          {
            label: 'User Email',
            name: 'email',
            placeholder: 'Search by user email',
          },
          // {
          //   label: 'Role',
          //   name: 'role',
          //   component: <Select options={ROLE_OPTIONS} allowClear />,
          // },
        ]}
      />

      <Table {...tableProps} rowKey="email">
        <Table.Column
          dataIndex="email"
          title="User Email"
          render={(value) => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="name"
          title="Name"
          render={(value) =>
            value ? (
              <TextField value={value} />
            ) : (
              <TextField value={'Kosong'} type="secondary" italic />
            )
          }
        />
        <Table.Column
          dataIndex="role"
          title="Role"
          render={(value) => <TextField value={value} />}
        />
        <Table.Column
          title="Actions"
          render={(_, record: TLMSAdmin) => {
            const editableFields = getEditableAdminFields({
              actorRole: LMSRole,
              targetRole: record.role,
            })
            const canUpdate = editableFields.length > 0
            const canDelete = canDeleteAdmin({
              actorRole: LMSRole,
              targetRole: record.role,
            })

            return (
              <Space>
                {canUpdate ? (
                  <EditButton
                    size="small"
                    onClick={() => {
                      setModalState({ type: 'update', admin: record })
                    }}
                  />
                ) : null}
                <Popconfirm
                  title="Are you sure want to delete this user?"
                  onConfirm={() => {
                    setModalState({ type: 'delete', admin: record })
                  }}
                  okButtonProps={{
                    danger: true,
                    type: 'default',
                  }}
                  okText="Delete"
                  disabled={!canDelete}
                >
                  <Button
                    size="small"
                    danger
                    icon={<Icons.DeleteOutlined />}
                    disabled={!canDelete}
                  >
                    Delete
                  </Button>
                </Popconfirm>
              </Space>
            )
          }}
        />
      </Table>
    </List>
  )
}
